import DashboardEvent from "../../dashboard/event/DashboardEvent";
import InternalStakeholderDefinition from "../../internal-stakeholders/model/InternalStakeholderDefinition";
import InternalStakeholdersModel from "../../internal-stakeholders/model/InternalStakeholdersModel";
import MapLocationAvailabilityEvent from "../../map/event/MapLocationAvailabilityEvent";
import MapModel from "../../map/model/MapModel";
import TeaCornerEvent from "../../tea-corner/event/TeaCornerEvent";

export default class HubSaveGameModel {

    /**
     * @constructor
     * @param {InternalStakeholdersModel} internalStakeholdersModel
     */
    constructor(dispatcher, internalStakeholdersModel) {
        this._dispatcher = dispatcher;
        this._internalStakeholdersModel = internalStakeholdersModel;

        this._enabledDashboard = false;
        this._enabledTeaCorner = false;
        this._internalStakeholders = {};
        this._mapLocations = {};
        this._characters = {};
    }

    enableDashboard(enabled = true) {
        this._enabledDashboard = enabled;
    }

    enableTeaCorner(enabled = true) {
        this._enabledTeaCorner = enabled;
    }

    enableInternalStakeholder(id, enabled = true) {
        this._internalStakeholders[id] = enabled;
    }

    enableMapLocation(id, enabled = true) {
        this._mapLocations[id] = enabled;
    }

    enableCharacter(id, enabled = true) {
        this._characters[id] = enabled;
    }

    restoreHubState() {
        const dashboardVisibilityEvent = this._enabledDashboard ? DashboardEvent.ENABLE_DASHBOARD_BUTTON : DashboardEvent.DISABLE_DASHBOARD_BUTTON;
        this._dispatcher.dispatch(dashboardVisibilityEvent);

        const teacornerVisibilityEvent = this._enabledTeaCorner ? TeaCornerEvent.ENABLE_TEA_CORNER_BUTTON : TeaCornerEvent.DISABLE_TEA_CORNER_BUTTON;
        this._dispatcher.dispatch(teacornerVisibilityEvent);

        for (let internalStakeholder in this._internalStakeholders) {
            let internalStakeholderDefinition = new InternalStakeholderDefinition(internalStakeholder);
            if (this._internalStakeholders[internalStakeholder]) {
                this._internalStakeholdersModel.activateInternalStakeholder(internalStakeholderDefinition);
            } else {
                this._internalStakeholdersModel.deactivateInternalStakeholder(internalStakeholderDefinition);
            }
        }

        for (let character in this._characters) {
            const locationEvent = this._characters[character] ? MapLocationAvailabilityEvent.CHARACTER_AVAILABLE : MapLocationAvailabilityEvent.CHARACTER_UNAVAILABLE;
            const mapLocationAvailabilityEvent = new MapLocationAvailabilityEvent(locationEvent, character);
            this._dispatcher.dispatch(mapLocationAvailabilityEvent.type, { data: mapLocationAvailabilityEvent });
        }

        for (let mapLocation in this._mapLocations) {
            const locationEvent = this._mapLocations[mapLocation] ? MapLocationAvailabilityEvent.LOCATION_AVAILABLE : MapLocationAvailabilityEvent.LOCATION_UNAVAILABLE;
            const mapLocationAvailabilityEvent = new MapLocationAvailabilityEvent(locationEvent, mapLocation);
            this._dispatcher.dispatch(mapLocationAvailabilityEvent.type, { data: mapLocationAvailabilityEvent });
        }
    }

    toObject() {
        return {
            enabledDashboard: this._enabledDashboard,
            enabledTeaCorner: this._enabledTeaCorner,
            internalStakeholders: this._internalStakeholders,
            mapLocations: this._mapLocations,
            characters: this._characters
        }
    }

    fromObject(obj) {
        this._enabledDashboard = obj.enabledDashboard;
        this._enabledTeaCorner = obj.enabledTeaCorner;
        this._internalStakeholders = obj.internalStakeholders;
        this._mapLocations = obj.mapLocations;
        this._characters = obj.characters;
    }
}